module.exports = "/images/accordion-minus.svg?20437bd60d5c8a508cb067b2112017db";